function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg8",
    viewBox: "-0.2 0 179.99987 139.9997",
    height: "199.99959mm",
    width: "257.14267mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-368.10267,-436.00491)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#b6bfcc",
      fillOpacity: 1
    },
    id: "g976-5",
    transform: "matrix(-1,0,0,1,547.90253,279.00468)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6bfcc",
      fillOpacity: 1,
      strokeWidth: 0.99231249
    },
    d: "M 43.011719,593.38672 C 19.183691,593.38672 0,612.56845 0,636.39648 v 443.11332 c 0,23.828 19.183691,43.0097 43.011719,43.0097 H 259.35156 c 23.82803,0 43.00977,-19.1817 43.00977,-43.0097 V 636.39648 c 0,-23.82803 -19.18174,-43.00976 -43.00977,-43.00976 z m 52.421875,17.59766 H 206.92969 c 2.61732,0 4.72461,2.10728 4.72461,4.7246 0,2.61733 -2.10729,4.72461 -4.72461,4.72461 H 95.433594 c -2.617323,0 -4.72461,-2.10728 -4.72461,-4.72461 0,-2.61732 2.107287,-4.72461 4.72461,-4.7246 z M 18.898438,640.81641 H 283.46484 V 1037.666 H 18.898438 Z M 151.18164,1057.6621 a 22.677165,22.677165 0 0 1 22.67578,22.6777 22.677165,22.677165 0 0 1 -22.67578,22.6778 22.677165,22.677165 0 0 1 -22.67773,-22.6778 22.677165,22.677165 0 0 1 22.67773,-22.6777 z",
    transform: "scale(0.26458333)",
    id: "rect29-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6bfcc",
      fillOpacity: 1,
      strokeWidth: 0.99231249
    },
    d: "m 313.69922,820.1582 v 18.89844 H 632.88477 V 1103.623 H 311.7832 c -2.26589,7.3429 -6.43848,13.83 -11.94336,18.8965 h 337.46485 c 23.82799,0 43.00976,-19.1817 43.00976,-43.0097 V 863.16992 c 0,-23.82803 -19.18177,-43.01172 -43.00976,-43.01172 z m 344.29297,90.70899 c 2.61732,0 4.72464,2.10728 4.72461,4.72461 v 111.4961 c 0,2.6173 -2.10729,4.7246 -4.72461,4.7246 -2.61733,0 -4.72461,-2.1073 -4.72461,-4.7246 V 915.5918 c 0,-2.61733 2.10728,-4.72461 4.72461,-4.72461 z",
    transform: "scale(0.26458333)",
    id: "rect29-6-5"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(2.8782402,102.05357,176.04761)",
    style: {
      fill: "#b6bfcc",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    },
    d: "m 86.556549,176.80356 11.295432,-7.27737 11.295429,-7.27738 0.4127,8.41163 c 24.23505,-1.22321 44.29656,9.50022 49.79096,36.05847 C 145.4813,184.52732 134.30524,179.58253 110.05329,180.868 l 0.40347,8.22245 -11.950106,-6.14345 z",
    id: "path958-6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateMobile);
export default __webpack_public_path__ + "static/media/Rotate_Mobile.b3ca04bfcf8616e9b58bbcd76d8f5f1c.svg";
export { ForwardRef as ReactComponent };